// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    ICheckoutSessionItem,
}                               from '../interfaces';

const getCheckoutSessionItem = async ({
    test,
    paymentIntentId,
}: {
    test: boolean,
    paymentIntentId: string,
}): Promise<ICheckoutSessionItem> => {
    const functions = getFunctions();
    const handleGetCheckoutSessionItem = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        ICheckoutSessionItem
    >(
        functions,
        'getCheckoutSessionItem',
    );
    return handleGetCheckoutSessionItem({
        test,
        paymentIntentId,
    }).then((result) => {
        const session = result.data as ICheckoutSessionItem;
        return session;
    }).catch((err) => {
        throw err;
    });
};

export default getCheckoutSessionItem;
